import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FeeCategoryProvider } from "@/contexts/FeeCategoryContext";
import Index from "./pages/Index";
import MunicipalityDetail from "./pages/MunicipalityDetail";
import ComparisonPage from "./pages/ComparisonPage";
import ComparisonDetailPage from "./pages/ComparisonDetailPage";
import MapPage from "./pages/MapPage";
import AboutPage from "./pages/AboutPage";
import SharePage from "./pages/SharePage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <FeeCategoryProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/municipality/:id" element={<MunicipalityDetail />} />
            <Route path="/sammenlign" element={<ComparisonPage />} />
            <Route path="/sammenligne-detalj" element={<ComparisonDetailPage />} />
            <Route path="/kart" element={<MapPage />} />
            <Route path="/del" element={<SharePage />} />
            <Route path="/om" element={<AboutPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </FeeCategoryProvider>
  </QueryClientProvider>
);

export default App;
